module.exports = __webpack_public_path__ + "media/components/assets/icons/close_24-54158216109b2d8827f786be6b1d76ed.svg";